export default [{
        name: 'Zemen Lobby',
        icon: 'nc-icon nc-shop',
        children: [{
                name: 'Food Menu',
                path: '/lobbyfood/list',

            },
            {
                name: 'Drink Menu',
                path: '/lobbydrink/list',

            },
        ],
    },
    {
        name: 'Zemen Breakfast',
        icon: 'nc-icon nc-planet',
        children: [{
            name: 'Breakfast Menu',
            path: '/lobbybreakfast/list',

        }],
    },
    {
        name: 'Room Service',
        icon: 'nc-icon nc-basket',
        children: [{
                name: 'Food Menu',
                path: '/roomfood/list',

            },
            {
                name: 'Drink Menu',
                path: '/roomdrink/list',

            },
        ],
    },
    {
        name: 'Enset Restaurant',
        icon: 'nc-icon nc-delivery-fast',
        children: [{
                name: 'Food Menu',
                path: '/restaurantfood/list',

            },
            {
                name: 'Drink Menu',
                path: '/restaurantdrink/list',

            },
        ],
    },
    {
        name: 'Fiker Lounge',
        icon: 'nc-icon nc-bookmark-2',
        children: [{
                name: 'Food Menu',
                path: '/loungefood/list',

            },
            {
                name: 'Drink Menu',
                path: '/loungedrink/list',

            },
        ],
    },
    {
        name: 'Room Directory',
        icon: 'nc-icon nc-camera-compact',
        path: '/directory/edit',
    },
]